import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from "vue";
  import router from "@/router";
  import { useStore } from "vuex";
  import { POSITION, useToast } from "vue-toastification";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmRegistrationView',
  setup(__props, { expose: __expose }) {
  __expose();

  const toast = useToast();
  const store = useStore();
  const showSpinner = ref(false);
  const { redirectUrl } = router.currentRoute.value.query;

  const isDefaultConfirmRegistration = computed(() => {
    return router.currentRoute.value.name === "ConfirmRegistration";
  });

  const verify = (token: string) => {
    const action = isDefaultConfirmRegistration.value
      ? "user/verify"
      : "user/verifyUnregisteredCustomer";

    showSpinner.value = true;
    setTimeout(() => {
      store
        .dispatch(action, token)
        .then(() => {
          toast.success("Email was verified successfully", {
            position: POSITION.TOP_LEFT,
            timeout: 3000,
          });
          setTimeout(() => {
            router.push(
              isDefaultConfirmRegistration.value ? String(redirectUrl) : "/"
            );
          }, 3000);
        })
        .catch(() => {
          toast.error("The link has expired", {
            position: POSITION.TOP_LEFT,
            timeout: 3000,
          });
          setTimeout(() => {
            router.push("/");
          }, 3000);
        })
        .finally(() => {
          showSpinner.value = false;
        });
    }, 1200);
  };

  onMounted(() => {
    const { id } = router.currentRoute.value.params;

    verify(String(id));
  });

const __returned__ = { toast, store, showSpinner, redirectUrl, isDefaultConfirmRegistration, verify, computed, onMounted, ref, get router() { return router }, get useStore() { return useStore }, get POSITION() { return POSITION }, get useToast() { return useToast } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})